import { Paginated, PaginatedWithSummary } from '@orderna/admin-panel/src/types/pagination';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import moment from 'moment';
import { QueryOptionsMapper } from '../../../mapper/query-options.mapper';
import { AllTransaction } from '../../../../model/all-transaction';

export class AllTransactionApiMapper {
  static fromDto(dto: any): Paginated<AllTransaction> {
    const { data = [], meta } = dto ?? {};

    return {
      data: data.map((o: any, index: number): AllTransaction => {
        return {
          id: index,
          date: moment(o.date, moment.ISO_8601, true).isValid()
            ? o.date
            : new Date(),
          paymentMethod: o.paymentMethod,
          status: o.status,
          revenue: o.revenue ?? 0,
          costOfGoods: o.costOfGoods ?? 0,
          grossProfit: o.grossProfit ?? 0,
          serviceFee: o.serviceFee ?? 0,
          tip: o.tip ?? 0,
          refund: o.refund ?? 0,
          tax: o.tax ?? 0,
        };
      }),
      pagination: {
        page: meta.page,
        totalPages: Math.ceil(meta.total / meta.size),
        total: meta.total,
        size: meta.size,
      },
    };
  }

  static toFilterDto(options: QueryOptions<AllTransaction>) {
    return {
      ...QueryOptionsMapper.toStoreFilterDto(options),
      ...QueryOptionsMapper.toDynamicPeriodDto(options),
      ...QueryOptionsMapper.toPaginationDto(options),
      ...QueryOptionsMapper.toSortOrderDto(options),
      ...this.toSortByDto(options),
      ...this.toTransactionStatusDto(options),
    };
  }

  private static toTransactionStatusDto(options: QueryOptions<AllTransaction>) {
    const filter = options.filters?.find((f) => f.field === 'status');
    if (!filter) return null;

    return { status: filter.value };
  }

  private static toSortByDto(options: QueryOptions<AllTransaction>) {
    const field = options.sort?.field;
    if (!field) return null;

    return { sortBy: this.toSortBy(field) };
  }

  private static toSortBy(field: string) {
    switch (field) {
      case 'date':
        return 'transaction_timestamp';
      case 'paymentMethod':
        return 'payment_type';
      case 'status':
        return 'status';
      case 'revenue':
        return 'net_sales';
      case 'costOfGoods':
        return 'total_cost';
      case 'grossProfit':
        return 'gross_profit';
      case 'serviceFee':
        return 'total_service_charge';
      case 'tip':
        return 'tip';
      case 'refund':
        return 'total_refund';
      case 'tax':
        return 'total_sales_tax';
      default:
        throw new Error(`Field does not exist: ${field}`);
    }
  }
}
